import React from 'react';
import { isWidgetEnabled, WidgetContext } from '../../data/widgets/WidgetContext';
import { getMatchIdOrStageId } from '../utils';
import { getEnv } from '../env';

function ScoreAndTime(props) {
    const widgetContext = React.useContext(WidgetContext);
    const widgetEnabled = isWidgetEnabled(props.sportRef,props.widgetType,props.geniusId,props.lsportWidgetId);

    function toggleLiveTracker() {
        const containerId = `#br_widget_checkbet_${props.ticketRef}_${props.id}`;
        if (widgetContext.widgetContainerId !== containerId) {
            if (widgetEnabled) {
                widgetContext.setWidget({
                    widgetGeniusId: props.geniusId,
                    widgetLsportId: props.lsportWidgetId,
                    widgetProviderType: props.widgetType,
                    widgetSportId: props.sportRef,
                    widgetStartCollapsed: true,
                    widgetS5Layout: '#2',
                    widgetMatchId: getMatchIdOrStageId(props),
                    widgetContainerId: containerId
                });
            }
        } else if (props.id !== widgetContext.widgetMatchId) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(props)
            });
        } else {
            widgetContext.setWidget({
                widgetMatchId: null,
                widgetContainerId: null
            });
        }
    }

    return (
        <div className={"d-flex align-items-center margine-su-giu pointer"/* + classIf(props.state === 'in_progress', 'live-container')*/} onClick={() => {}}>
            {props.state === 'in_progress' && 
                <span className="live-badge"></span>

            }
            {props.partialScores.length > 0 &&
                <>
                    <div className="d-flex align-items-flex-end">
	                    <span className="text-small bold grey">
		                    {props.partialScores.map((score, i) => {
		                    	let showableScore = score;
		                    	if (showableScore.indexOf('#') >= 0) {
		                    		const disc = showableScore.split('#')[0];
		                    		const effec = showableScore.split('#')[1];
		                    		showableScore = `(${disc}) ${effec}`;
		                    	}
		                    	showableScore = showableScore.replace(":", " - ");
		                        return (
		                            <React.Fragment key={i}>
		                                &nbsp;
		                                <span className="text-small bold grey">{showableScore}</span>
		                            </React.Fragment>
		                        )
		                    })} 
	                    </span>
                    </div>
                    &nbsp;
                </>
            }
            {props.timing != null &&
                <>
                    <span className={"text-small grey " + (props.state === 'in_progress'? 'lampeggia' : '')}>{props.timing}</span>
                    &nbsp;
                </>
            }
            {(props.id != null && isWidgetEnabled(props.sportRef,props.widgetType,props.geniusId,props.lsportWidgetId)) &&
                <img src={`${getEnv('PUBLIC_URL')}/assets/images/widget-campetto.png`} alt="" onClick={toggleLiveTracker} />
            }
        </div>
    );
}

export default ScoreAndTime;